import React from "react";
import "./Company.css";

const Company = () => {
  return (
    <div className="c-wrapper">
      <div className="c-container innerWidth">
        <img src="https://real-estate-web.pages.dev/prologis.png" alt="Prologis" />
        <img src="https://real-estate-web.pages.dev/tower.png" alt="Tower" />
        <img src="https://real-estate-web.pages.dev/equinix.png" alt="Equinix" />
        <img src="https://real-estate-web.pages.dev/realty.png" alt="Realty" />
      </div>
    </div>
  );
};

export default Company;
